import Page from 'v5/chapterDashboard/ChapterDashboardRelayPage.bs'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'
import { withMainLayout } from '../../pagesComponents/MainApp'

const MyDashboardpage = requireAuthenticatedAgent(Page)

MyDashboardpage.getLayout = withMainLayout

export default MyDashboardpage
